import { Injectable } from '@angular/core';

import * as uuid from 'uuid';

/**
 * Service to generate random unique identifiers
 *
 * @export
 */
@Injectable({
    providedIn: 'root',
})
export class UUIDService {
    /**
     * Generates a random unique identifier
     *
     * @param [guid=false] optional parameter to defined if the generated uuid has the GUID format.
     * @returns the unique identifier string.
     */
    generate(guid: boolean = false): string {
        let id = uuid.v4();

        if (!guid) {
            id = id.replace(/-/g, '');
        }

        return id;
    }

    /**
     * indicates whether or not the text / identifier is uuid
     * @param text the text / identifier to check
     * @param guid the identifier format
     */
    isUUID(text: string, guid: boolean = true): boolean {
        let regexp: RegExp;

        if (guid) {
            regexp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
        } else {
            regexp = /^[0-9a-fA-F]{32}$/gi;
        }
        
        return regexp.test(text);
    }
}
